import axios from 'axios';
import {
  APP_SETTING_LOAD_SNIPPET_SNAPSHOTS_BEGIN,
  APP_SETTING_LOAD_SNIPPET_SNAPSHOTS_SUCCESS,
  APP_SETTING_LOAD_SNIPPET_SNAPSHOTS_FAILURE,
  APP_SETTING_LOAD_SNIPPET_SNAPSHOTS_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function loadSnippetSnapshots(args = {}) {
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_LOAD_SNIPPET_SNAPSHOTS_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/snippet-snapshots/${projectId}/project`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: APP_SETTING_LOAD_SNIPPET_SNAPSHOTS_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: APP_SETTING_LOAD_SNIPPET_SNAPSHOTS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadSnippetSnapshotsError() {
  return {
    type: APP_SETTING_LOAD_SNIPPET_SNAPSHOTS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_LOAD_SNIPPET_SNAPSHOTS_BEGIN:
      return {
        ...state,
        loadSnippetSnapshotsPending: true,
        loadSnippetSnapshotsError: null,
      };

    case APP_SETTING_LOAD_SNIPPET_SNAPSHOTS_SUCCESS:
      return {
        ...state,
        loadSnippetSnapshotsPending: false,
        loadSnippetSnapshotsError: null,
        snippetSnapshots: action.data ? action.data : [],
      };

    case APP_SETTING_LOAD_SNIPPET_SNAPSHOTS_FAILURE:
      return {
        ...state,
        loadSnippetSnapshotsPending: false,
        loadSnippetSnapshotsError: action.data.error,
      };

    case APP_SETTING_LOAD_SNIPPET_SNAPSHOTS_DISMISS_ERROR:
      return {
        ...state,
        loadSnippetSnapshotsError: null,
      };

    default:
      return state;
  }
}
